import { translate } from 'react-translate'

import DateLocationFormat from './date-location-format'

export default translate('Configurations')(DateLocationFormat)
